module.exports = __webpack_public_path__ + "img/product-1.1724f912.jpg";